// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-2024-js": () => import("./../../../src/pages/2024.js" /* webpackChunkName: "component---src-pages-2024-js" */),
  "component---src-pages-2025-js": () => import("./../../../src/pages/2025.js" /* webpackChunkName: "component---src-pages-2025-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-playground-js": () => import("./../../../src/pages/playground.js" /* webpackChunkName: "component---src-pages-playground-js" */)
}

